/**
 * Created by Gayratjon Rayimjonov on 10/24/2017.
 */
(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsPeriodical', StatsPeriodical)
        .factory('StatsByCountry', StatsByCountry);

    StatsPeriodical.$inject = ['$resource', 'DateUtils'];

    function StatsPeriodical($resource, DateUtils) {
        var resourceUrl = 'api/stats-periodical';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
    }

    StatsByCountry.$inject = ['$resource', 'DateUtils'];

    function StatsByCountry($resource) {
        var resourceUrl = 'api/stats-by-country';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
